// This loads and registers all controllers from the controllers directory
import { application } from "$js/controllers/application"

import { Tabs } from "tailwindcss-stimulus-components"

// Import and register all controllers manually since stimulus-loading is importmap-specific
import AlertController from "$js/controllers/alert_controller"
import BulkImportController from "$js/controllers/bulk_import_controller"
import CheckboxTogglerController from "$js/controllers/checkbox_toggler_controller"
import ClassTogglerController from "$js/controllers/class_toggler_controller"
import ClipboardController from "$js/controllers/clipboard_controller"
import ConfettiController from "$js/controllers/confetti_controller"
import ContentSwapController from "$js/controllers/content_swap_controller"
import CookieToggleController from "$js/controllers/cookie_toggle_controller"
import CountUpController from "$js/controllers/count_up_controller"
import DiffingUploaderController from "$js/controllers/diffing_uploader_controller"
import DismissableController from "$js/controllers/dismissable_controller"
import DropdownController from "$js/controllers/dropdown_controller"
import EventDispatcherController from "$js/controllers/event_dispatcher_controller"
import FileUploaderController from "$js/controllers/file_uploader_controller"
import FormAutoSubmitController from "$js/controllers/form_auto_submit_controller"
import HamburgerController from "$js/controllers/hamburger_controller"
import ModalController from "$js/controllers/modal_controller"
import MultiselectController from "$js/controllers/multiselect_controller"
import NavigationBarTourController from "$js/controllers/navigation_bar_tour_controller"
import OutputMapperController from "$js/controllers/output_mapper_controller"
import Select2Controller from "$js/controllers/select2_controller"
import SelectionListController from "$js/controllers/selection_list_controller"
import SpreadsheetController from "$js/controllers/spreadsheet_controller"
import TableFilterController from "$js/controllers/table_filter_controller"
import TrixAugmenterController from "$js/controllers/trix_augmenter_controller"
import TypeaheadSearchController from "$js/controllers/typeahead_search_controller"
import ViewTogglerController from "$js/controllers/view_toggler_controller"

// Register all controllers
application.register("alert", AlertController)
application.register("bulk-import", BulkImportController)
application.register("checkbox-toggler", CheckboxTogglerController)
application.register("class-toggler", ClassTogglerController)
application.register("clipboard", ClipboardController)
application.register("confetti", ConfettiController)
application.register("content-swap", ContentSwapController)
application.register("cookie-toggle", CookieToggleController)
application.register("count-up", CountUpController)
application.register("diffing-uploader", DiffingUploaderController)
application.register("dismissable", DismissableController)
application.register("dropdown", DropdownController)
application.register("event-dispatcher", EventDispatcherController)
application.register("file-uploader", FileUploaderController)
application.register("form-auto-submit", FormAutoSubmitController)
application.register("hamburger", HamburgerController)
application.register("modal", ModalController)
application.register("multiselect", MultiselectController)
application.register("navigation-bar-tour", NavigationBarTourController)
application.register("output-mapper", OutputMapperController)
application.register("select2", Select2Controller)
application.register("selection-list", SelectionListController)
application.register("spreadsheet", SpreadsheetController)
application.register("table-filter", TableFilterController)
application.register("tabs", Tabs)
application.register("trix-augmenter", TrixAugmenterController)
application.register("typeahead-search", TypeaheadSearchController)
application.register("view-toggler", ViewTogglerController)
